// Module
var code = " <ng-content></ng-content>";
// Exports
module.exports = code;